import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/layouts/default.vue").then(m => m.default || m)),
  "login-layout": defineAsyncComponent(() => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/layouts/login-layout.vue").then(m => m.default || m)),
  "ticket-layout": defineAsyncComponent(() => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/layouts/ticketLayout.vue").then(m => m.default || m))
}